import {
  sampling, getMainDomain, setCookie, setSS, getSS, getLS, setLS, delLS, hasFlag, getTimezoneName,
} from '../../../modules/utils';

const { ROUTE_REQUIRE_ENUM } = require('./constant');

const DEFAULT_BIZ = 'hk';

// 初始化业务码
function bizInit($hobbit) {
  $hobbit.$ctx.setBiz = biz => {
    if (biz in $hobbit.$config.site.bizs) {
      $hobbit.$ctx.biz = biz;
      setSS($hobbit.$config.site.bizKey, biz);
    }
  };
  $hobbit.$ctx.getBiz = () => {
    // 1、首先通过URL参数获取业务码
    let biz = $hobbit.$ctx.query[$hobbit.$config.site.bizKey];
    if (biz in $hobbit.$config.site.bizs) {
      return biz;
    }

    // 2、其次通过本地存储获取业务码
    biz = getSS($hobbit.$config.site.bizKey);
    if (biz in $hobbit.$config.site.bizs) {
      return biz;
    }

    // 3、最后通过业务线域名通过配置计算业务码
    for (const code in $hobbit.$config.site.bizs) {
      if ($hobbit.$config.site.bizs[code].host?.test(window.location.host)) {
        return code;
      }
    }
    console.warn(`未能识别出业务线，将使用默认业务线码: ${DEFAULT_BIZ}`);
    return DEFAULT_BIZ;
  };
  $hobbit.$ctx.setBiz($hobbit.$ctx.getBiz());
}

/**
 * 语言模块初始化
 */
function langInit($hobbit) {
  // 实现与扩展语言模块基础功能：获取一级路径语言码
  $hobbit.$ctx.LANG_PATH_REGEXP = /^\/([a-z]{2}-[a-z]{2})\/?/i;
  $hobbit.$ctx.getLangByPath = (path = window.location.pathname) => {
    const pathLang = $hobbit.$ctx.LANG_PATH_REGEXP.exec(path);
    if (pathLang && pathLang[1]) return pathLang[1].toLowerCase();
    return null;
  };

  // 实现与扩展语言模块基础功能：判断语言方向
  $hobbit.$ctx.isRTL = (biz = $hobbit.$ctx.biz, lang = $hobbit.$ctx.revertLang ?? $hobbit.$ctx.lang) => {
    const langExtInfo = $hobbit.$config.site.bizs[biz]?.langs?.[lang];
    return langExtInfo && langExtInfo.dir === 'rtl';
  };

  // 实现与扩展语言模块基础功能：设置/切换语言
  $hobbit.$ctx.setLang = (lang, updateURL = false, updateApp = true) => {
    // 更新内存和持久化到本地的语言码
    $hobbit.$ctx.lang = lang;
    if ($hobbit.$config.site.noLangPath) {
      setLS($hobbit.$config.site.langKey, lang);
    } else {
      // 兼容旧版本语言码存储逻辑
      setCookie($hobbit.$config.site.langKey, lang, new Date().dateAdd(365), '/');
    }

    // 更新URL
    if (updateURL && window.history.pushState) {
      const oldLang = $hobbit.$ctx.getLangByPath();
      if (!oldLang || oldLang !== lang) {
        const replacePath = `${window.location.pathname.replace($hobbit.$ctx.LANG_PATH_REGEXP, `/${lang}/`)}${window.location.search}${window.location.hash}`;
        window.history.replaceState(window.history.state, null, replacePath);
      }
    }

    // 同步到App
    if (updateApp) {
      const langExtInfo = $hobbit.$config.site.bizs[$hobbit.$ctx.biz]?.langs?.[lang];
      if (langExtInfo) {
        window.$hobbit.$bridge.call({
          name: 'setting/updateLanguage',
          version: 3,
          params: {
            lang,
            appLangCode: langExtInfo.appLangCode,
          },
          timeout: 1e4,
        });
      }
    }

    // 加载新语言资源
    return $hobbit.$resources.$installer.install(lang);
  };

  // #region 语言获取逻辑
  const supportLangs = $hobbit.$config.site.bizs[$hobbit.$ctx.biz]?.langs ?? {};
  // 0. 识别出URL中一级目录的语言码
  const pathLang = $hobbit.$ctx.getLangByPath();
  if (pathLang && $hobbit.$config.site.noLangPath) {
    // 删除路径中的语言码
    const removeLangPath = `${window.location.pathname.replace($hobbit.$ctx.LANG_PATH_REGEXP, '/')}${window.location.search}${window.location.hash}`;
    window.history.replaceState(window.history.state, null, removeLangPath);
  }

  // 1. URL参数中指定的语言码
  let targetLang = $hobbit.$ctx.query[$hobbit.$config.site.langKey];
  if (!(targetLang in supportLangs)) {
    targetLang = pathLang;

    // 2. LocalStorge中存储的语言码
    if (!(targetLang in supportLangs)) {
      targetLang = getLS($hobbit.$config.site.langKey);

      // 3. 识别浏览器语言，计算出来的最接近的语言码
      if (!(targetLang in supportLangs)) {
        for (const lang in supportLangs) {
          if (navigator.language?.toLowerCase()?.includes(lang.split('-')[0])) {
            targetLang = lang;
            break;
          }
        }

        // 4. 根据业务线指定的默认语言码（兜底）
        if (!(targetLang in supportLangs)) {
          targetLang = Object.keys(supportLangs)[0];
        }
      }
    }
  }
  // #endregion 语言获取逻辑

  // 设置语言
  return $hobbit.$ctx.setLang(targetLang, false, false);
}

function apiStat(response, $hobbit) {
  // 调试输出
  if (response.source !== $hobbit.$fetch.SOURCE.AJAX && !$hobbit.$ctx.isProd()) {
    // eslint-disable-next-line no-console
    console.log(`%c$fetch:${response.source} ${response.options.url}`, 'color:#6f6', response);
  }
  // 接口监控统计
  window.setTimeout(() => {
    const checkout = response.options.apiLogSampling ?? $hobbit.$config.log.defaultApiLogSampling;
    const hitSampling = sampling(checkout);
    if (response.errorCode || hitSampling) {
      let content = null;
      try {
        content = response.errorCode ? JSON.stringify(response.options.params) : undefined;
      } catch (ex) {
        content = String(ex);
      }
      $hobbit.$log.api(`${response.options.method}-${response.options.url}`, {
        errorCode: response.errorCode,
        errorMessage: response.errorMessage,
        code: response.httpCode,
        message: response.httpMessage,
        duration: response.endTime - response.startTime,
        content,
        source: response.source,
        qos: response.retry ? 1 : 0,
        checkout: hitSampling ? checkout : undefined,
      });
    }
  }, 0);
}

/**
 * 计算页面性能统计指标
 */
function performanceStat(mounted) {
  const stat = {};
  if (window.$hobbit.$ctx.pageIndex > 1) {
    stat.reason = 'pageIndex';
    return stat;
  }

  // 页面挂载时间点
  if (mounted) {
    stat.mounted = Math.ceil(mounted);
  }

  // 当前时间
  if (window.performance?.now) {
    stat.currentTime = Math.ceil(window.performance?.now());
  }

  // 首次渲染时间点
  if (window.performance?.getEntriesByName) {
    const paintEntries = window.performance.getEntriesByName('first-contentful-paint');
    if (paintEntries && paintEntries.length) {
      stat.fcp = Math.ceil(paintEntries[0].startTime);
    }
  }

  if (!window.performance?.getEntriesByType) {
    stat.reason = 'getEntriesByType';
    return stat;
  }

  const navEntries = window.performance.getEntriesByType('navigation');
  if (!navEntries || !navEntries.length) {
    stat.reason = 'navEntries';
    return stat;
  }
  const nav = navEntries[0];
  // onload时间
  if (nav.loadEventEnd) {
    stat.duration = Math.ceil(nav.loadEventEnd);
  }

  // 启动耗时
  if (!nav.domainLookupStart) {
    stat.reason = 'domainLookupStart';
    return stat;
  }
  stat.createTime = Math.ceil(nav.domainLookupStart);

  // 域名解析耗时（domainLookupEnd - domainLookupStart）
  if (!nav.domainLookupEnd) {
    stat.reason = 'domainLookupEnd';
    return stat;
  }
  stat.dns = Math.ceil(nav.domainLookupEnd - nav.domainLookupStart);

  // 建立TCP连接耗时（connectEnd - domainLookupEnd）
  if (!nav.connectEnd) {
    stat.reason = 'connectEnd';
    return stat;
  }
  stat.op_time = Math.ceil(nav.connectEnd - nav.domainLookupEnd);

  // 请求准备阶段耗时（requestStart - connectEnd）
  if (!nav.requestStart) {
    stat.reason = 'requestStart';
    return stat;
  }
  stat.schedule_time = Math.ceil(nav.requestStart - nav.connectEnd);

  // 请求响应耗时（responseStart- requestStart）
  if (!nav.responseStart) {
    stat.reason = 'responseStart';
    return stat;
  }
  stat.responseTime = Math.ceil(nav.responseStart - nav.requestStart);
  stat.fp = Math.ceil(nav.responseStart); // 首包时间点

  // 数据传输耗时（responseEnd - responseStart）
  if (!nav.responseEnd) {
    stat.reason = 'responseEnd';
    return stat;
  }
  stat.server_time = Math.ceil(nav.responseEnd - nav.responseStart);

  // 数据解析耗时（domContentLoadedEventStart - responseEnd）
  if (!nav.domContentLoadedEventStart) {
    stat.reason = 'domContentLoadedEventStart';
    return stat;
  }
  stat.time_cost = Math.ceil(nav.domContentLoadedEventStart - nav.responseEnd);

  // Dom解析耗时（domContentLoadedEventEnd - domContentLoadedEventStart）
  if (!nav.domContentLoadedEventEnd) {
    stat.reason = 'domContentLoadedEventEnd';
    return stat;
  }
  stat.dom_cost = Math.ceil(nav.domContentLoadedEventEnd - nav.domContentLoadedEventStart);
  stat.domloaded = Math.ceil(nav.domContentLoadedEventEnd);

  return stat;
}

function logInit($hobbit) {
  // 设置神策用户ID
  const userId = $hobbit.$user.vkUserId();
  if (userId) {
    $hobbit.$log.syncUserId(`${$hobbit.$ctx.biz}-${userId}`);
  }

  // 设置项目通用埋点固定数据
  $hobbit.$log.setCommonParams({
    product: $hobbit.$config.log.appName, // 项目名称 2023
    session_id: $hobbit.$ctx.sessionID ?? '', // 会话ID 2023
    device_id: $hobbit.$ctx.deviceID ?? '', // 设备ID 2023
    system: $hobbit.$ctx.system, // 系统 2023
    client: $hobbit.$ctx.client, // 客户端类型 2023
    view: $hobbit.$ctx.view, // 视图 2023
    $app_version: $hobbit.$ctx.version, // 版本 2023
    env: $hobbit.$ctx.runtime, // 环境 2023
    runtime: $hobbit.$ctx.isProd() ? 'normal' : 'test', // 运行时 2023
  });

  // 设置通用埋点动态数据
  $hobbit.$log.beforeSendStat = (eventType, params) => {
    const nowTime = new Date().getTime();
    params.timestamp = nowTime; // 客户端时间戳 2023
    params.pageIndex = $hobbit.$ctx.isNewDevice ? -1 : $hobbit.$ctx.pageIndex; // 软跳转次数 2023
    if ($hobbit.$ctx.startPage) {
      params.startpage = $hobbit.$ctx.startPage.name; // 起始页名称 2023
      params.startspan = nowTime - $hobbit.$ctx.startPage.time; // 起始页打开时长 2023
    }
    if ($hobbit.$ctx.currPage) {
      params.currpage = $hobbit.$ctx.currPage.name; // 当前页名称 2023
      params.currspan = nowTime - $hobbit.$ctx.currPage.time; // 当前页打开时长 2023
      if ($hobbit.$ctx.prevPage) {
        params.prevpage = $hobbit.$ctx.prevPage.name; // 前一页名称 2023
        params.prevspan = $hobbit.$ctx.currPage.time - $hobbit.$ctx.prevPage.time; // 前一页停留时长 2023
      }
    }
    params.$url = window.location.href; // 当前URL 2023
    params.parent_id = $hobbit.$user.vkUserId() ?? ''; // 家长ID 2023
    params.student_id = $hobbit.$user.vkStudentId() ?? ''; // 学生ID 2023
    params.urlhash = window.location.hash; // hash 2023
    params.vklang = $hobbit.$ctx.lang;
    params.crcode = $hobbit.$ctx.biz; // 业务码 2023
    params.chfrom = $hobbit.$ctx.channel ?? ''; // 站外渠道 2023
    params.refcode = $hobbit.$ctx.referralCode ?? ''; // 转介绍码 2023
    if ($hobbit.$ctx.appInfo?.name) {
      params.app_name = $hobbit.$ctx.appInfo?.name;
      params.app_build_version = `${$hobbit.$ctx.appInfo?.protocol}/${$hobbit.$ctx.appInfo?.version}`;
    }
    // 分级渠道上报逻辑（支持.隔开多个级别）
    if ($hobbit.$ctx.channelLevel) {
      $hobbit.$ctx.channelLevel.split('.').forEach((level, index) => {
        params[`chlevel_${$hobbit.$log.LETTER_SEQUENCE[index]}`] = level; // 分级渠道 2023
      });
    }
    params.vkab = $hobbit.$log.bean2LogString($hobbit.$abtest.getABRecord()); // AB实验 2023
    // 记录代理员信息
    if ($hobbit.$ctx.agentinfo) {
      params.Staff_id = $hobbit.$ctx.agentinfo.staffId;
      params.scene = $hobbit.$ctx.agentinfo.scene;
    }
  };

  // 实现自动上报页面PV的方法
  $hobbit.$log.autoSendPV = (vue) => {
    const mounted = window.performance?.now ? window.performance.now() : 0;
    const islanding = ($hobbit.$ctx.prevPage === null
      && getMainDomain(document.referrer).toLowerCase() !== getMainDomain().toLowerCase())
      ? 1 : 0;
    Promise.race([
      $hobbit.$ctx.onload,
      new Promise(resolve => window.setTimeout(() => resolve('TIMEOUT'), 2e3)),
    ]).then(() => {
      $hobbit.$log.view(vue.$route.meta.pv, {
        $referrer: document.referrer,
        $title: document.title,
        islanding,
        ...performanceStat(mounted),
      });
    });
  };
}

function getVKTimezone() {
  const tzOffset = new Date().getTimezoneOffset();
  const tzHH = `0${parseInt(Math.abs(tzOffset) / 60, 10)}`.slice(-2);
  const tzMM = `0${Math.abs(tzOffset) % 60}`.slice(-2);
  return `GMT${tzOffset > 0 ? '-' : '+'}${tzHH}:${tzMM}`;
}

function error404Init($hobbit, router) {
  router.beforeEach((to, from, next) => {
    if (to.matched?.length) {
      next();
    } else {
      window.location.href = `/${$hobbit.$ctx.lang}/website/service/error404/?path=${encodeURIComponent(to.fullPath)}`;
    }
  });
}

/**
 * 默认请求头设置
 */
function getDefaultFetchBeforeRequest($hobbit) {
  return item => {
    if (!item.preventDefaultHeader) {
      const defaultHeaders = {};
      let vkDevice = 'PC';
      if ($hobbit.$ctx.client === $hobbit.$ctx.CLIENT.PC_App) vkDevice = 'PC_APP';
      if ($hobbit.$ctx.isMO()) vkDevice = 'H5';
      defaultHeaders['vk-device'] = vkDevice;
      defaultHeaders['vk-session-id'] = $hobbit.$ctx.sessionID ?? '';
      if ($hobbit.$ctx.biz) defaultHeaders['vk-cr-code'] = $hobbit.$ctx.biz;
      if ($hobbit.$ctx.lang) defaultHeaders['vk-language'] = $hobbit.$ctx.revertLang ?? $hobbit.$ctx.lang;
      if ($hobbit.$ctx.vkTimezone) defaultHeaders['vk-timezone'] = $hobbit.$ctx.vkTimezone;
      if ($hobbit.$ctx.vkBusDomain) defaultHeaders['vk-bus-domain'] = $hobbit.$ctx.vkBusDomain;
      if ($hobbit.$user?.vkToken) defaultHeaders.Authorization = $hobbit.$user.vkToken();
      // 添加代理员信息
      if ($hobbit.$ctx.agentInfo) {
        defaultHeaders.staffAuth2Uc = 'auth';
        defaultHeaders.jwtToken = $hobbit.$ctx.agentInfo.code;
        defaultHeaders.scene = $hobbit.$ctx.agentInfo.scene;
      }
      item.headers = {
        ...defaultHeaders,
        ...item.headers,
      };
    }
  };
}

/**
 * 代理员信息初始化
 */
function vipAgentInit($hobbit, router) {
  const keyOfLS = 'agentInfo';

  // 为$ctx扩展出设置或清除代理员信息的方法
  $hobbit.$ctx.setAgentInfo = (info) => {
    if (info === null) {
      delete $hobbit.$ctx.agentInfo;
      $hobbit.$ctx.timezone = getTimezoneName();
      $hobbit.$ctx.vkTimezone = getVKTimezone();
      delLS(keyOfLS); // 彻底删除该LS item
    } else {
      $hobbit.$ctx.agentInfo = info;
      $hobbit.$ctx.timezone = info.timezone;
      $hobbit.$ctx.vkTimezone = info.timezone;
    }
  };

  // 尝试读取来自oauth页设置的代理员信息
  const agentInfo = getLS(keyOfLS);
  if (agentInfo) {
    // 有代理员信息，需要设置到$ctx中，并在路由跳转时进行权限校验
    $hobbit.$ctx.setAgentInfo(agentInfo);
    // 添加页面代理员权限校验
    router.beforeEach((to, from, next) => {
      // 没有代理员信息（说明已经退出登录，退出代理员模式），那么则不再需要校验权限了
      if (!$hobbit.$ctx.agentInfo) {
        next();
        return;
      }

      // 如果有代理员信息，则需要继续校验登录态和权限
      const vkToken = $hobbit.$user.vkToken();
      if (vkToken) {
        // 登录状态下才需要权限校验
        if (to.meta.agentAuth?.includes('*') || to.meta.agentAuth?.includes($hobbit.$ctx.agentInfo?.scene)) {
          next();
        } else {
          console.warn('vipAgentInit 权限拦截', to, from);
          window.location.href = `/${$hobbit.$ctx.lang}/website/service/error403/`;
        }
      } else {
        // 没登录，则清除代理员信息
        $hobbit.$ctx.setAgentInfo(null);
        next();
      }
    });
  }
}

/**
 * 登录校验逻辑初始化
 */
function loginCheckInit($hobbit, router, themeInstalled) {
  router.beforeEach((to, from, next) => {
    if (to.meta?.login && !to.query?.preview && !to.query?.isadmin) {
      // 强制验证登录
      Promise.all([$hobbit.$ctx.onAppReady, themeInstalled]).then(() => {
        $hobbit.$user.isLogin(true, to.fullPath).then(next);
      });
    } else {
      next();
    }
  });
}

/**
 * 引擎配置安装
 */
function themeInstall($hobbit, bizCode) {
  $hobbit.$theme.$installer.load = biz => Promise.all([
    import(/* webpackChunkName: "[request]" */`@/theme/${biz}.js`).then(theme => theme.default),
    $hobbit.$fetch.get({
      url: `/rest/gw/api/platform/businessBasic/config/${$hobbit.$ctx.biz}`,
      headers: { 'vk-cr-code': bizCode },
      timeout: 5e3,
      cache: {
        online: 600 * 1000,
      },
    }),
  ]).then(resps => {
    Object.assign(resps[0]?.default.prop, resps[1]?.data?.data);
    return resps[0];
  });
  return $hobbit.$theme.$installer.install(bizCode);
}

/**
 * 路由前置校验逻辑初始化
 */
function routerPreCheckInit($hobbit, router, themeInstalled) {
  router.beforeEach((to, from, next) => {
    if (to.meta?.require && !to.query?.preview && !to.query?.isadmin) {
      Promise.all([$hobbit.$ctx.onAppReady, themeInstalled]).then(async () => {
        const backurl = to.fullPath;
        // 路由配置字段
        const require = to.meta.require;
        // 1. 强制验证登录
        if (hasFlag(require, ROUTE_REQUIRE_ENUM.MUST_LOGIN)) {
          const isLogin = await $hobbit.$user.isLogin(true, backurl);
          if (!isLogin) {
            return;
          }
        }
        let studentList = [];
        // 2. 统一拦截账号下没孩子
        if (hasFlag(require, ROUTE_REQUIRE_ENUM.HAS_CHILD)) {
          studentList = await $hobbit.$user.getStudentInfo(true, undefined, undefined, undefined, backurl);
          if (studentList.length === 0) {
            return;
          }
        }
        // 3. 拦截系统默认孩子
        if (hasFlag(require, ROUTE_REQUIRE_ENUM.SELF_CHILD)) {
          const sysCreated = studentList.find(student => !!student?.initial);
          if (sysCreated) {
            // 把当前孩子切换成系统默认孩子
            $hobbit.$user.vkStudentId(sysCreated.studentId ?? sysCreated.id);
            const search = `?from=supplement&backurl=${encodeURIComponent(backurl)}`;
            $hobbit.$app.pageReplace(`${$hobbit.$theme.addchildURL}${search}`);
          }
        }
        next();
      });
    } else {
      next();
    }
  });
}

export default {
  bizInit,
  langInit,
  apiStat,
  logInit,
  getVKTimezone,
  error404Init,
  vipAgentInit,
  loginCheckInit,
  getDefaultFetchBeforeRequest,
  themeInstall,
  routerPreCheckInit,
  langSupportCheck: () => 1, // 向前兼容
};
